// Set request destination
const apiNode = document.getElementsByTagName("HTML")[0].getAttribute("data-apinode");


const addPostRequest = (languageLink) => {
    const language = languageLink.getAttribute("data-lang-code");
    const reqPath = window.location.origin + "/Language/Set?Language=" + language + "&contentLink=" + encodeURIComponent(apiNode);

    // Add click event listener to language links
    languageLink.firstElementChild.addEventListener("click", async (event) => {
        event.preventDefault();
        try {
            // Any link I click, sends a request to the same path
            // But body is different to each link
            let response = await fetch(reqPath, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                }
            });

            let url = await response.json();

            window.location = url;

        } catch (err) {
            // Error handling
            console.error("Something went wrong");
        }
    })
}

// LanguageSelector
const languageDropdownItems = document.querySelector(".adm-dropdown-content-util-right").children;
for (const item in languageDropdownItems) {
    if (!isNaN(+item)) {
        const languageLink = languageDropdownItems.item(+item);
        addPostRequest(languageLink);
    }
}

// MobileLanguageSelector
const languageMobileItems = document.querySelectorAll(".adm-dropdown-content-menu-mobile .adm-li-nav-mobile-language");
for (const item in languageMobileItems) {
    if (!isNaN(+item)) {
        const languageLink = languageMobileItems.item(+item);
        addPostRequest(languageLink);
    }
}